import type { FC } from 'react';
import { Button, Card } from '@components/UI';

interface FilterBacktestsBulkActionsProps {
    selectedCount: number;
    onDeleteSelectedClick: () => void;
}

const FilterBacktestsBulkActions: FC<FilterBacktestsBulkActionsProps> = ({ selectedCount, onDeleteSelectedClick }) => {
    if (selectedCount === 0) {
        return null;
    }

    return (
        <Card className="mb-3">
            <div className="px-4 py-3 flex flex-wrap items-center justify-between gap-3">
                <div className="text-sm text-zinc-200">
                    Selected <strong>{selectedCount}</strong> backtest
                    {selectedCount === 1 ? '' : 's'}.
                </div>
                <div className="flex flex-wrap gap-2">
                    <Button variant="danger" onClick={onDeleteSelectedClick}>
                        Delete selected
                    </Button>
                </div>
            </div>
        </Card>
    );
};

export default FilterBacktestsBulkActions;
